import ReviewScreen from 'features/lineOfCredit/screens/review/ReviewScreen';
import React from 'react';

export default function Page() {
  return <ReviewScreen />;
}
